import { FC, KeyboardEvent, ReactNode } from 'react'
import classNames from 'classnames'
import PerIcon from '../../../components/custom_components/Icon'
import PerText from '../../../components/custom_components/Text'

export type DashboardActiveFilterPillProps = {
  selected: boolean
  onClick: () => void
  children: ReactNode
  className?: string
  /** When true (e.g. appraisal monitoring active filters), the clear icon stays visible; office chips keep hover-only. */
  closeAlwaysVisible?: boolean
}

const DashboardActiveFilterPill: FC<DashboardActiveFilterPillProps> = ({
  selected,
  onClick,
  children,
  className,
  closeAlwaysVisible = false,
}) => {
  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <div
      className={classNames(
        'dashboard-active-filter-pill',
        { 'dashboard-active-filter-pill--selected': selected, 'dashboard-active-filter-pill--close-always-visible': closeAlwaysVisible },
        className,
      )}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <PerText fontSize="xs" color={selected ? 'white' : 'default'} className="dashboard-active-filter-pill__label">
        {children}
      </PerText>
      {selected && (
        <span className="dashboard-active-filter-pill__close" aria-hidden>
          <PerIcon name="close_stroke" color="white" size={10} variant="decoration" />
        </span>
      )}
    </div>
  )
}

export default DashboardActiveFilterPill
